import React from 'react';
import ServiceData from './ServiceData';

const ServicesFeature = () => {
    return (
        <section style={{ backgroundColor: '#f9f9f9', padding: '100px 0' }}>
            <div className="auto-container">
                <div style={{ textAlign: 'center', marginBottom: '60px' }}>
                    <h5 style={{ color: '#25b579', fontWeight: '700', fontSize: '14px', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '15px' }}>WHAT WE DO</h5>
                    <h2 style={{ color: '#0a3d62', fontSize: 'clamp(2.5rem, 4vw, 3.5rem)', fontWeight: '300', margin: 0 }}>
                        Specialist <strong style={{ fontWeight: '700' }}>Property Services</strong>
                    </h2>
                </div>
                <div className="row clearfix" style={{ justifyContent: 'center' }}>
                    {ServiceData.map((service) => (
                        <div
                            key={service.id}
                            className="col-lg-5 col-md-6 col-sm-12"
                            style={{ padding: '0 15px', marginBottom: '30px', cursor: 'pointer' }}
                            onClick={() => window.location.href = service.detailslink}
                        >
                            <div 
                                className="service-card"
                                style={{ 
                                    position: 'relative', 
                                    overflow: 'hidden', 
                                    borderRadius: '12px', 
                                    boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    height: '100%',
                                    backgroundColor: '#ffffff',
                                    border: '1px solid #eaeaea',
                                    transition: 'all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1)'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-8px)';
                                    e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.1)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.05)';
                                }}
                            >
                                <div style={{ backgroundImage: `url(${service.image})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '260px', width: '100%', borderBottom: '1px solid #eaeaea' }}></div>
                                <div style={{ padding: '35px', display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                                    <h4 style={{ color: '#0a3d62', fontSize: '1.5rem', fontWeight: '700', marginBottom: '15px' }}>
                                        {service.title}
                                    </h4>
                                    <p style={{ color: '#555555', fontSize: '1.05rem', lineHeight: 1.6, margin: 0 }}>
                                        {service.desc}
                                    </p>
                                    <div style={{ marginTop: 'auto', paddingTop: '20px' }}>
                                        <span style={{ color: '#25b579', fontWeight: '600', fontSize: '0.95rem', display: 'flex', alignItems: 'center' }}>
                                            Learn more <i className="fas fa-arrow-right" style={{ marginLeft: '8px', fontSize: '0.85rem' }}></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ServicesFeature;
